// Shared shift helpers so Settings shift timings drive every screen.
export function formatShift(s) {
  return `${s.name} (${s.start}-${s.end})`;
}

function toMin(t) {
  const m = /(\d{1,2}):(\d{2})/.exec(t || '');
  return m ? (+m[1]) * 60 + (+m[2]) : null;
}

// Returns the shift name whose window covers the given Date (handles overnight shifts).
export function shiftForDate(shifts, d) {
  if (!shifts?.length || !d || Number.isNaN(d.getTime?.())) return '—';
  const mins = d.getHours() * 60 + d.getMinutes();
  for (const s of shifts) {
    const a = toMin(s.start);
    const b = toMin(s.end);
    if (a == null || b == null) continue;
    const inRange = a <= b ? (mins >= a && mins < b) : (mins >= a || mins < b);
    if (inRange) return s.name;
  }
  return '—';
}
